import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  GET: 'GET',
  FIND: 'FIND',
};

export const getProfile = () => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_ACCOUNT}profile/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const searchProfile = (pageSize, page, sorted, filtered) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_ACCOUNT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sorted => sorted.desc ? `-${sorted.id}` : sorted.id ).join(',')
        : null,
    },
  });
};

export const findAccountByUsername = (username) => {
  return {
    type: ACTION.FIND,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_ACCOUNT,
      params: {
        username,
      },
    }),
  };
};



// WEBPACK FOOTER //
// ./src/redux/profile/profile_actions.js